// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue, {createApp} from 'vue'
import App from './App'
import router, { homeLink } from './router'
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle, faFileUpload, faMoneyBillAlt, faStarOfLife, faChild, faKey, faBusinessTime, faUtensils, faBeer, faSearch, faMinusCircle, faBookReader, faTruck, faTruckMonster, faHandPointLeft, faFileSignature } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import OktaVue from '@okta/okta-vue'
import { OktaAuth } from '@okta/okta-auth-js'

library.add(faInfoCircle, faFileUpload, faMoneyBillAlt, faStarOfLife, faChild, faKey, faBusinessTime, faUtensils, faBeer, faSearch, faMinusCircle, faBookReader, faTruck, faTruckMonster, faHandPointLeft, faFileSignature)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(BootstrapVue)
Vue.config.productionTip = false
Vue.config.silent = true
Vue.config.errorHandler = () => null;
Vue.config.warnHandler = () => null;


export const oktaAuth = new OktaAuth({
    issuer: `${process.env.VUE_APP_OKTA_DOMAIN}/oauth2/default`,
    clientId: process.env.VUE_APP_CLIENT_ID,
    redirectUri: window.location.origin + '/callback',
    scopes: ['openid', 'profile'],
    pkce: true,
})

const app = createApp(App);
app.use(OktaVue, { oktaAuth })
app.use(router);
// $homeLink: the home route plus whatever tile filter (?q= / ?dept=) was last
// active, used by the "Return to info.my.vermont.gov" links on help pages.
// A getter, so it stays reactive to the stored query.
Object.defineProperty(app.config.globalProperties, '$homeLink', {
    get: homeLink,
});
app.mount("#app");
